const translations = {
    exemptionNumberErrorMessage: 'Invalid Exemption Number. Example: ABC123',
    maxExceededErrorMessage: 'Too many characters',
    requiredErrorMessage: 'This field is required'
};

export default translations;
